import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'ark-ui-chip',
  templateUrl: './ui-chip.component.html',
  styleUrls: ['./ui-chip.component.scss'],
})
export class UiChipComponent {
  @Input() label!: string;
  @Input() labelDescription!: string;
  @Input() selected = false;

  @Output() selectionChanged = new EventEmitter<boolean>();

  constructor() {}

  toggle() {
    this.selected = !this.selected;
    this.selectionChanged.emit(this.selected);
  }
}
